import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RouterKeys } from "./RouterKeys";

const AuthProtect = ({ children }) => {
    const accessToken = useSelector((state) => state?.auth?.adminToken);

    // Redirect unauthenticated users to login
    if (!accessToken) {
        return children;
    }

      return <Navigate to={RouterKeys.NON_Auth.DASHBOARD} />;
};

export default AuthProtect;
